<template>
  <div class='downloadApp'>
    <div class="dl_box">
        <div class="title">
            须在APP下使用，请安装
        </div>
        <div class="close" @click="changeStatus">
            <img src="/img/closeicon.png" alt="">
        </div>
        <div class="tip qr">
            <div class="qr_t">
                1.扫码下载安装
            </div>
            <div style="text-align: center;">
                <!-- <canvas id="downloadAppQR" class="downloadAppQR" ref="downloadAppQR"></canvas> -->
                <div id="downloadAppQR" ref="downloadAppQR" class="downloadAppQR"></div>
            </div>
        </div>
        <div class="d_btn">
            <div>
                2.点击按钮下载安装
            </div>
            <a :href="downloadUrl" target="_blank">
                <button class="btn">
                    立即下载
                </button>
            </a>
        </div>
    </div>
  </div>
</template>

<script>
// import QRCode from 'qrcode'
export default {
    name: 'UmDownloadApp',
    data(){
        return {
            downloadUrl: "https://" + $UMCore.getHost() + "/dapp.html#/androiddownload",
        };
    },
    mounted() {
        this.useqrcode();
    },
    updated() {
        this.useqrcode();
    },
    methods: {
        changeStatus(){
            this.$emit("showTip", false)
        },
        useqrcode(){
            // var canvas = this.$refs.downloadAppQR;
            // QRCode.toCanvas(canvas, "https://dapp.umnet.cn/apps/download/UMGrit.apk", function (error) {
            // if (error) console.error(error)
            // })
            // $(".downloadAppQR").width(250);
            // $(".downloadAppQR").height(250);
            var url = "https://dapp.umnet.cn/apps/download/UMGrit.apk"
            $("#downloadAppQR").html("");
            this.$nextTick(() => {
              let qrcode1 = new QRCode("downloadAppQR", {
                width: 250,
                height: 250,
                text: url, // 二维码地址
                colorDark: "#000",
                colorLight: "#fff"
              });
            });
        },
    },
}

</script>
<style lang='scss' scoped>
.downloadApp{
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, .7);
    z-index: 2000;
    display: flex;
    justify-content: center;
    align-items: center;
    .dl_box{
        background: #fff;
        padding: 15px 25px;
        border-radius: 5px;
        position: relative;
        .title{
            font-size: 16px;
            color: #333333;
            text-align: center;
        }
        .close{
            position: absolute;
            right: 11px;
            top: 8px;
            img{
                width: 15px;
                height: 15px;
            }
        }
        .tip{
            margin-top: 20px;
            font-size: 15px;
            color: #333333;
        }
        .qr{
            #downloadApp{
                width: 225px;
                height: 225px;
            }
        }
        .d_btn{
            .btn{
                width: 80%;
                height: 45px;
                background: #2E9CF1;
                color: #ffffff;
                border: none;
                font-size: 15px;
                text-align: center;
                line-height: 45px;
                border-radius: 3px;
                margin: 0 auto;
                margin-top: 15px;
                display: block;
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/packages/downloadAppTip/um-download-app.vue